import Vue from 'vue'
import App from './App.vue'
import router from './router'

import en from '@/lang/en'

import global from '@/utils/global'
Vue.prototype.$global = global

import uploader from 'vue-simple-uploader'
Vue.use(uploader)


Vue.config.productionTip = false

import Axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, Axios)

import { Uploader } from 'vant';
import { Tab, Tabs } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Popup } from 'vant';

Vue.use(Popup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Uploader);


Vue.directive('i18n', {
  bind: (el, binding) => {
    if(!binding.value && typeof el.innerHTML === 'string') {
      let tmp = el.innerHTML
      el.innerHTML = ''
      binding.value = tmp
    }    

    for(let key in en) {
      if(binding.value == key) {
        let domZH = document.createElement('div')
        domZH.innerHTML = binding.value
        domZH.classList.add('v-i18n-zh')
        el.insertBefore(domZH, el.firstChild)

        let domEN = document.createElement('div')
        domEN.innerHTML = en[key]
        domEN.classList.add('v-i18n-en')
        el.insertBefore(domEN, el.firstChild)

      }
    }
  },

})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
